import React, { FunctionComponent } from "react";
import styles from "./Card.module.scss";
import CardProps from "./CardProps.interface";

import { useInView } from "react-intersection-observer";
import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Paragraph from "components/Paragraph/Paragraph";
import Button from "components/Button/Button";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";

const Card: FunctionComponent<CardProps> = (props) => {
    const [wrapperElementRef, inView] = useInView({ triggerOnce: false, threshold: 0.4, rootMargin: "50% -40px 50% 0px" });
    const isInViewClass = inView === true ? "in_view" : undefined;

    const image = props.content.image ? props.content.image : undefined;
    const imageCrop = getImageCrop(image?.umbracoFile.crops, props.settings.imageCrop, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, image?.umbracoWidth, image?.umbracoHeight);

    return (
        <div className={combineClasses(styles.wrapper, isInViewClass)} ref={wrapperElementRef}>
            <div className={styles.inner}>
                {/* Media */}
                {props.content.image ? (
                    <div className={styles.image_wrapper}>
                        {/* Badge */}
                        <div className={styles.badge}>
                            {props.content.badge_primary ? (
                                <strong className={styles.badge_primary}>{props.content.badge_primary}</strong>
                            ) : null}

                            {props.content.badge_secondary ? (
                                <span className={styles.badge_secondary}>{props.content.badge_secondary}</span>
                            ) : null}
                        </div>

                        {/* Image */}
                        <ImageViewer className={styles.image} src={props.content.image.umbracoFile.src} focalPoint={props.content.image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    </div>
                ) : null}

                {/* Content */}
                <div className={styles.content}>
                    {/* Heading */}
                    {props.content.heading ? (
                        <h3 className={styles.heading}>{props.content.heading}</h3>
                    ) : null}

                    {props.content.bodyText ? (
                        <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}

                    {/* Buttons */}
                    {props.content.buttons && props.content.buttons.length > 0 ? (
                        <div className={styles.buttons}>
                            {props.content.buttons.map(button => (
                                <Button key={button.contentUdi} to={button.content.link} variant={button.content.variant} {...button.content}>{button.content.label}</Button>
                            ))}
                        </div>
                    ) : null}
                </div>

                {/* Background */}
                {props.settings.cardBoxWrap?.[0]?.content?.backgroundMedia && props.settings.cardBoxWrap?.[0]?.content?.backgroundMedia.length > 0 ? (
                    <BackgroundMedia className={styles.background} {...props.settings.cardBoxWrap?.[0]?.content?.backgroundMedia?.[0]} />
                ) : null}
            </div>
        </div>
    );
};

export default Card;